import { useCallback, useContext } from "react";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import {
    impressionSplitMethodTab,
    clickSplitMethodTab,
    clickSplitConfirmCta,
    clickSplitEqually,
    impressionSplitError,
    impressionSplitSuccessWidget,
    clickSplitDoneCta,
    clickSplitUpiEntry,
    clickAddMoreGuest,
} from "@dineout-payment-success-ui/analytics/events";

export const useSplitBillAnalytics = () => {
    const { clickEvent, impressionEvent } = useContext(AnalyticsContext);

    const onImpressionSplitMethodTab = useCallback(
        (data: Parameters<typeof impressionSplitMethodTab>[1]) => {
            impressionSplitMethodTab(impressionEvent, data);
        },
        [impressionEvent],
    );

    const onClickSplitMethodTab = useCallback(
        (data: Parameters<typeof clickSplitMethodTab>[1]) => {
            clickSplitMethodTab(clickEvent, data);
        },
        [clickEvent],
    );

    const onClickSplitConfirmCta = useCallback(
        (data: Parameters<typeof clickSplitConfirmCta>[1]) => {
            clickSplitConfirmCta(clickEvent, data);
        },
        [clickEvent],
    );

    const onClickSplitEqually = useCallback(
        (data: Parameters<typeof clickSplitEqually>[1]) => {
            clickSplitEqually(clickEvent, data);
        },
        [clickEvent],
    );

    const onImpressionSplitError = useCallback(
        (data: Parameters<typeof impressionSplitError>[1]) => {
            impressionSplitError(impressionEvent, data);
        },
        [impressionEvent],
    );

    const onImpressionSplitSuccessWidget = useCallback(
        (data: Parameters<typeof impressionSplitSuccessWidget>[1]) => {
            impressionSplitSuccessWidget(impressionEvent, data);
        },
        [impressionEvent],
    );

    const onClickSplitDoneCta = useCallback(
        (data: Parameters<typeof clickSplitDoneCta>[1]) => {
            clickSplitDoneCta(clickEvent, data);
        },
        [clickEvent],
    );

    const onClickSplitUpiEntry = useCallback(
        (data: Parameters<typeof clickSplitUpiEntry>[1]) => {
            clickSplitUpiEntry(clickEvent, data);
        },
        [clickEvent],
    );

    const onClickAddMoreGuest = useCallback(
        (data: Parameters<typeof clickAddMoreGuest>[1]) => {
            clickAddMoreGuest(clickEvent, data);
        },
        [clickEvent],
    );

    return {
        onImpressionSplitMethodTab,
        onClickSplitMethodTab,
        onClickSplitConfirmCta,
        onClickSplitEqually,
        onImpressionSplitError,
        onImpressionSplitSuccessWidget,
        onClickSplitDoneCta,
        onClickSplitUpiEntry,
        onClickAddMoreGuest,
    };
};
